import { LucideIcon } from "lucide-react-native";
import { MedicalHistoryTextField } from "./MedicalHistoryTextField";

export type IconInputProps = {
  icon: LucideIcon;
  /** Every input must expose its purpose outside the placeholder. */
  label: string;
  hint?: string;
  error?: string;
  placeholder: string;
  value: string;
  onChangeText: (text: string) => void;
  keyboardType?: "default" | "numeric" | "email-address" | "phone-pad";
  multiline?: boolean;
  numberOfLines?: number;
  secureTextEntry?: boolean;
  autoCapitalize?: "none" | "sentences" | "words" | "characters";
};

/** Text input with an icon using the shared Medical History field chrome. */
export function IconInput({
  icon: Icon,
  label,
  hint,
  error,
  placeholder,
  value,
  onChangeText,
  keyboardType = "default",
  multiline = false,
  numberOfLines = 1,
  secureTextEntry = false,
  autoCapitalize = "sentences",
}: IconInputProps) {
  return (
    <MedicalHistoryTextField
      icon={Icon}
      label={label}
      hint={hint}
      error={error}
      placeholder={placeholder}
      value={value}
      onChangeText={onChangeText}
      keyboardType={keyboardType}
      multiline={multiline}
      numberOfLines={numberOfLines}
      secureTextEntry={secureTextEntry}
      autoCapitalize={autoCapitalize}
    />
  );
}
